import { type ReactNode } from "react";

import { QueryClientProvider } from "@tanstack/react-query";

export const WithProviders = ({ children }: { children: ReactNode }) => (
  <QueryClientProvider client={window.QUERY_CLIENT}>
    {children}
  </QueryClientProvider>
);
